import { transferPost } from '@/authority/services';
import { history } from '@umijs/max';
import { message } from 'antd';
import { useState } from 'react';
import { useRequest } from '@/hooks/requestHook';

export default () => {
    const [currentUser, setCurrentUser] = useState({});
    const [authority, setAuthority] = useState([]);
    const { fetchAPI } = useRequest();
    async function logout() {
        // const res = await transferPost('api.logout', '', 'DELETE');
        const res = await fetchAPI({
            url: '/logout',
            method: 'post',
        });

        const { code } = res.data || {};

        if (code === 0) {
            message.success('登出成功.');
            history.push({
                pathname: '/user/login',
            });
            setCurrentUser({});
        }
    }
    async function fetchCurrent() {
        const res = await fetchAPI({
            url: '/user_center/info',
            method: 'get',
        })

        console.log('roles info', res);
        const { code, data } = res.data || {};

        if (code === 0) {
            let currentUser = data;
            // console.log('currentUser', currentUser);
            setCurrentUser(currentUser);
            // 将 permissions_v2 保存到 authority
            setAuthority(currentUser.permissions_v2 || []);
        } else {
            // todo 此处取消注释
            history.push({
                pathname: '/user/login',
            });
            setCurrentUser({});
            setAuthority([]);
        }
    }
    return {
        currentUser,
        authority,
        logout,
        fetchCurrent,
    };
};
